export enum BackgroundCheckActions {
  ConductBackgroundCheck = 'backgroundCheck:ConductBackgroundCheck',
  ViewBackgroundCheck = 'backgroundCheck:ViewBackgroundCheck',
}
